// import { NO_DATA_TXT } from '@/src/components/publish/constant';
import { reportQueries } from '@/entities/report';
import { useEffect, useState } from 'react';

interface DetailProps {
    evlId: number;
    evlIemId: string;
    stntId: string;
    fdbDc?: string;
    subId: number;
    isStudent?: boolean;
    onRefetch?: () => void;
}

export const FeedbackTab: React.FC<DetailProps> = ({
    evlId,
    evlIemId,
    subId,
    stntId,
    fdbDc,
    isStudent,
    onRefetch,
}) => {
    const [feedbackVal, setFeedbackVal] = useState<string>(fdbDc ?? '');

    const evalFeedbackMod = reportQueries.share.postReportEvalFdbMod();
    const onSave = () => {
        const feedbackParam = {
            evlId,
            evlIemId,
            userId: stntId,
            fdbDc: feedbackVal,
            subId,
        };
        evalFeedbackMod.mutate(feedbackParam, {
            onSuccess: () => {
                if (onRefetch) {
                    onRefetch();
                }
            },
        });
    };

    const onChangeFdbDc = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
        if (isStudent) return; // 학생일 경우 입력 방지
        setFeedbackVal(e.target.value);
    };

    useEffect(() => {
        setFeedbackVal(fdbDc ?? ''); // fdbDc가 변경될 때마다 업데이트
    }, [fdbDc]);

    return (
        <>
            <div className="tab-report withCheck">
                <div
                    className="tab active"
                    title="선택됨"
                    id="tab_content01"
                    style={{ cursor: 'default' }}
                >
                    피드백
                </div>
            </div>

            <div id="tab_01" className="tab_con" style={{ display: 'block' }}>
                <div className="round-box">
                    <div className="feedback_box">
                        <div className="feed_box">
                            <textarea
                                placeholder={
                                    !isStudent
                                        ? '문제별로 피드백을 작성해 보세요. 입력한 피드백은 학생 리포트에도 동일하게 보입니다.'
                                        : undefined
                                }
                                title={!isStudent ? '문제별 피드백 작성' : undefined}
                                value={feedbackVal}
                                onChange={onChangeFdbDc}
                            />
                            {!isStudent && (
                                <button className="save_bt" onClick={onSave}>
                                    저장
                                </button>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
